// A single-panel Okendo widget is a region, not an orphan tab panel.
// Observe only each widget, and preserve tab semantics if tabs are enabled later.
document.querySelectorAll('[data-oke-widget]').forEach((widget) => {
  const sync = () => {
    const tabs = [...widget.querySelectorAll('[role="tab"]')];
    widget.querySelectorAll('.oke-w-panel[role="tabpanel"], .oke-w-panel[data-hb-review-region]').forEach((panel) => {
      const controlled = tabs.some((tab) => (tab.getAttribute('aria-controls') || '').split(/\s+/).includes(panel.id));
      if (controlled) {
        if (panel.hasAttribute('data-hb-review-region')) {
          panel.removeAttribute('data-hb-review-region');
          panel.setAttribute('role', 'tabpanel');
        }
      } else if (!tabs.length && (panel.getAttribute('aria-label') || panel.getAttribute('aria-labelledby'))) {
        panel.setAttribute('data-hb-review-region', '');
        if (panel.getAttribute('role') !== 'region') panel.setAttribute('role', 'region');
      }
    });
  };
  sync();
  new MutationObserver(sync).observe(widget, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['role', 'aria-controls', 'aria-label', 'aria-labelledby', 'id']
  });
});
